<template>
  <MobilePlanPartnerLogo
    :height="size"
    :logo="{
      url: `https://s1.statics.backmarket.com/mobile-plan/${partnerName}/logo.svg?clearCache=true`,
      description: '',
    }"
  />
</template>

<script setup lang="ts">
import MobilePlanPartnerLogo from '@backmarket/nuxt-layer-checkout/components/MobilePlanPartnerLogo/MobilePlanPartnerLogo.vue'

withDefaults(
  defineProps<{
    partnerName: string
    size?: number
  }>(),
  {
    size: 24,
  },
)
</script>
